<template>
  <div v-if="detailData">
    <div class="key-visual">
      <div class="contents">
        <div class="txt" :style="`color:${detailData.detailFont}`">
          <span v-html="detailData.project" />
          <br />
          {{ detailData.projectServiceName }}
        </div>
        <div class="info">
          <span class="name" :style="`color:${detailData.detailFont}`">
            {{ detailData.projectClientName }}
          </span>
          <span class="date" :style="`color:${detailData.detailFont}`">
            <!--            {{ detailData.releaseDate | dateFormat }}-->
            {{ detailData.releaseDate }}
          </span>
          <span class="desc" :style="`color:${detailData.detailFont}`">
            {{ detailData.projectType }}
          </span>
        </div>
      </div>
      <div
        class="bg"
        :style="{
          background: `url(${
            detailData.pcDetailImagePhysicalName
              ? imgUrl(detailData.pcDetailImagePhysicalName)
              : '#000'
          }) no-repeat center/cover`
        }"
      ></div>
    </div>

    <div
      class="project-desc"
      :style="{
        backgroundImage: `url(${
          detailData.projectDesc.worksFieldImageList.length > 0 &&
          detailData.projectDesc.worksFieldImageList[0].pcImagePhysicalName
            ? imgUrl(detailData.projectDesc.worksFieldImageList[0].pcImagePhysicalName)
            : '#fff'
        })`
      }"
    >
      <div class="inner" v-html="handleNewLine(detailData.projectDesc.fieldContents)"></div>
    </div>
    <div
      v-show="
        detailData.projectType === 'Video' &&
          (detailData.projectDesc.videoCode === 'Y' || detailData.projectDesc.videoCode === 'V')
      "
      style="aspect-ratio: 16 / 9; margin-top: 20px; margin-bottom: 20px; height: auto;"
      v-if="detailData.projectDesc.videoUrl"
      class="project-desc"
    >
      <div class="inner">
        <iframe
          id="player"
          type="text/html"
          width="640"
          height="360"
          :src="
            `https://www.youtube.com/embed/${detailData.projectDesc.videoUrl}?rel=0&amp;autoplay=0&mute=1`
          "
          frameborder="0"
          style="width:100%;height:100%; aspect-ratio: 16 / 9;"
          v-if="detailData.projectDesc.videoUrl && detailData.projectDesc.videoCode === 'Y'"
        ></iframe>
        <iframe
          id="player"
          type="text/html"
          width="640"
          height="360"
          :src="`https://player.vimeo.com/video/${detailData.projectDesc.videoUrl}`"
          frameborder="0"
          style="width:100%;height:100%;"
          v-if="detailData.projectDesc.videoUrl && detailData.projectDesc.videoCode === 'V'"
        ></iframe>
      </div>
    </div>

    <div
      class="project-goal"
      :style="{
        background: `url(${
          detailData.projectGoal && detailData.projectGoal.worksFieldImageList.length > 1
            ? imgUrl(detailData.projectGoal.worksFieldImageList[1].pcImagePhysicalName)
            : '#fff'
        } no-repeat center/cover)`
      }"
      v-if="detailData.projectGoal"
    >
      <div class="inner">
        <span
          class="tit"
          :style="
            `color:${
              detailData.projectGoal && detailData.projectGoal.color
                ? detailData.projectGoal.color
                : '#000'
            }`
          "
          >Project Goal</span
        >

        <div
          v-show="
            detailData.projectType &&
              detailData.projectGoal &&
              detailData.projectType === 'Video' &&
              (detailData.projectGoal.videoCode === 'Y' || detailData.projectGoal.videoCode === 'V')
          "
          style="aspect-ratio: 16 / 9; margin-top: 20px; margin-bottom: 20px; "
          v-if="detailData.projectGoal && detailData.projectGoal.videoUrl"
        >
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            :src="
              `https://www.youtube.com/embed/${detailData.projectGoal.videoUrl}?rel=0&amp;autoplay=0&mute=1`
            "
            frameborder="0"
            style="width:100%;height:100%;"
            v-if="
              detailData.projectGoal &&
                detailData.projectGoal.videoUrl &&
                detailData.projectGoal.videoCode &&
                detailData.projectGoal.videoCode === 'Y'
            "
          ></iframe>
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            :src="`https://player.vimeo.com/video/${detailData.projectGoal.videoUrl}`"
            frameborder="0"
            style="width:100%;height:100%;"
            v-if="detailData.projectGoal.videoUrl && detailData.projectGoal.videoCode === 'V'"
          ></iframe>
        </div>
        <img
          :src="
            `${
              detailData.projectGoal && detailData.projectGoal.worksFieldImageList.length > 1
                ? imgUrl(detailData.projectGoal.worksFieldImageList[1].pcImagePhysicalName)
                : 'about:blank'
            }`
          "
          class="logo"
          alt=""
          v-show="
            detailData.projectType &&
              detailData.projectGoal &&
              (detailData.projectType !== 'Video' || detailData.projectGoal.videoCode === 'G')
          "
        />
        <span
          class="desc"
          v-html="handleNewLine(detailData.projectGoal.fieldContents)"
          :style="
            `color:${
              detailData.projectGoal && detailData.projectGoal.color
                ? detailData.projectGoal.color
                : '#000'
            }`
          "
        ></span>
      </div>
    </div>

    <div
      v-for="(item, index) in detailData.projectInfo"
      :key="`info${index}`"
      class="project-info"
      :style="{backgroundColor: item.bgColor, color: item.color}"
    >
      <div class="contents">
        <div class="title-box">
          <div
            class="tit"
            :style="{color: item.color}"
            v-html="handleNewLine(item.fieldTitleOne)"
          ></div>
          <div
            class="desc"
            :style="{color: item.color}"
            v-html="handleNewLine(item.fieldContents)"
          ></div>
        </div>
        <div
          v-show="
            detailData.projectType === 'Video' && (item.videoCode === 'Y' || item.videoCode === 'V')
          "
          style="aspect-ratio: 16 / 9; margin-top: 20px; margin-bottom: 20px; "
          v-if="item.videoUrl"
        >
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            :src="`https://www.youtube.com/embed/${item.videoUrl}?rel=0&amp;autoplay=0&mute=1`"
            frameborder="0"
            style="width:100%;height:100%;"
            v-if="item.videoUrl && item.videoCode === 'Y'"
          ></iframe>
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            :src="`https://player.vimeo.com/video/${item.videoUrl}`"
            frameborder="0"
            style="width:100%;height:100%;"
            v-if="item.videoUrl && item.videoCode === 'V'"
          ></iframe>
        </div>
        <img
          :src="imgUrl(item.worksFieldImageList[0].pcImagePhysicalName)"
          class="logo"
          alt=""
          v-if="item.worksFieldImageList.length > 0"
          v-show="detailData.projectType !== 'Video' || item.videoCode === 'G'"
        />
      </div>
    </div>

    <div class="contents" v-if="detailData.designConcept.length > 0">
      <h2 class="section-title">Design Concept</h2>
    </div>

    <div
      v-for="(item, index) in detailData.designConcept"
      :key="`concept${index}`"
      class="project-info design-concept"
      :style="{backgroundColor: item.bgColor, color: item.color}"
    >
      <div class="contents">
        <div class="title-box">
          <div
            class="tit"
            :style="{color: item.color}"
            v-html="handleNewLine(item.fieldTitleOne)"
          ></div>
          <div class="desc" :style="{color: item.color || ''}" v-html="item.fieldContents"></div>
        </div>
        <div
          v-show="
            detailData.projectType === 'Video' && (item.videoCode === 'Y' || item.videoCode === 'V')
          "
          style="aspect-ratio: 16 / 9; margin-top: 20px; margin-bottom: 20px; "
          v-if="item.videoUrl"
        >
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            :src="`https://www.youtube.com/embed/${item.videoUrl}?rel=0&amp;autoplay=0&mute=1`"
            frameborder="0"
            style="width:100%;height:100%;"
            v-if="item.videoUrl && item.videoCode === 'Y'"
          ></iframe>
          <iframe
            id="player"
            type="text/html"
            width="640"
            height="360"
            :src="`https://player.vimeo.com/video/${item.videoUrl}`"
            frameborder="0"
            style="width:100%;height:100%;"
            v-if="item.videoUrl && item.videoCode === 'V'"
          ></iframe>
        </div>
        <img
          :src="imgUrl(item.worksFieldImageList[0].pcImagePhysicalName)"
          class="logo"
          alt=""
          v-if="
            item.worksFieldImageList.length > 0 && item.worksFieldImageList[0].pcImagePhysicalName
          "
        />
      </div>
    </div>

    <div class="interview">
      <div class="inner">
        <div class="info">
          <h2 class="section-title">PROJECT INTERVIEW</h2>
          <p
            v-if="detailData.interview"
            v-html="handleNewLine(detailData.interview.interviewContents)"
          ></p>
          <ul>
            <li v-for="(item, index) in detailData.creditList" :key="index">
              <strong>{{ item.creditPosition }}</strong>
              <span>{{ item.creditName }}</span>
            </li>
          </ul>
        </div>
        <!--       <img :src="require('@/assets/images/@temp/work_detail3.png')" alt="" />-->
        <div class="pm-img" v-if="detailData.interview">
          <img :src="imgUrl(detailData.interview.intervieweePcImagePhysicalName)" alt="" />
        </div>
      </div>
    </div>

    <div class="similar-projects" v-if="detailData.similarProjectList && detailData.similarProjectList.length > 0">
      <div class="similar-inner">
        <h2 class="similar-title">
          <em>{{ detailData.projectServiceName }}</em>과 유사한 프로젝트
        </h2>
      </div>
      <div v-swiper:similarSwiper="swiperSimilar" class="similar-swiper">
        <div class="swiper-wrapper">
          <div
            v-for="item in detailData.similarProjectList.slice(0, 5)"
            :key="item.id"
            class="swiper-slide similar-slide"
          >
            <a
              href="javascript:;"
              class="similar-link"
              @click.prevent="goSimilarProject(item.id)"
            >
              <div class="thumb">
                <img :src="imgUrl(item.pcSmallImagePhysicalName)" :alt="item.projectServiceName" />
              </div>
              <div class="info">
                <i class="circle" />
                <div class="title">{{ item.projectServiceName }}</div>
                <div class="desc">{{ item.projectType }}</div>
                <span class="more">Read More</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="similar-inner">
        <div class="back-btn-wrap">
          <router-link to="/works" class="back-btn">
            <img class="ico-project" src="@/assets/images/ico-project-more.svg" alt="" />
            <span class="txt">Back to All Project</span>
            <img class="ico-arrow" src="@/assets/images/ico-arrow-up.svg" alt="" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {apiWorksDetail} from "@/api";
  import {Power0, TweenMax} from "gsap";
  import {mapGetters} from "vuex";
  import {commonMethods} from "@/utils/common-methods";
  import bus from "@/utils/bus";

  export default {
    name: "worksDetail",
    data() {
      return {
        scene: null,
        detailData: null,
        swiperSimilar: {
          slidesPerView: "auto",
          spaceBetween: 75,
          freeMode: true,
          observer: true,
          observeParents: true,
          // Swiper가 드래그 판정으로 첫 클릭을 막는 현상 방지
          preventClicks: false,
          preventClicksPropagation: false,
          threshold: 10
        }
      };
    },
    computed: {
      ...mapGetters(["GE_CONT_HEIGHT"])
    },
    watch: {
      GE_CONT_HEIGHT() {
        if (this.$el.offsetParent) {
          this.init();
        }
      },
      // 유사 프로젝트 클릭 등 같은 컴포넌트에서 id만 바뀔 때 상세 재조회
      "$route.params.id"(id, prevId) {
        if (!id || id === prevId) return;
        this.fetchData(true);
      }
    },
    activated() {
      this.init();
    },
    mixins: [commonMethods],
    methods: {
      goSimilarProject(id) {
        if (!id || String(this.$route.params.id) === String(id)) return;
        this.$router.push(`/works/${id}`);
      },
      init() {
        this.scene?.destroy(true);
        const keyVisual = document.querySelector(".key-visual");
        if (!keyVisual) return;

        const tween = TweenMax.to(keyVisual.querySelector(".bg"), 1, {
          y: keyVisual.clientHeight,
          ease: Power0.easeInOut
        });
        const tween2 = TweenMax.to(keyVisual.querySelector(".txt"), 1, {
          y: keyVisual.clientHeight + keyVisual.querySelector(".txt").clientHeight,
          ease: Power0.easeInOut
        });
        const tween3 = TweenMax.to(keyVisual.querySelector(".info"), 1, {
          y: keyVisual.clientHeight + 200,
          ease: Power0.easeInOut
        });
        this.scene = this.$scrollmagic
          .scene({
            triggerElement: keyVisual,
            triggerHook: 0,
            duration: keyVisual.clientHeight * 2
          })
          .setTween([tween, tween2, tween3]);
        this.$scrollmagic.addScene(this.scene);
        document.querySelectorAll(".project-info").forEach(el => {
          const tw = TweenMax.fromTo(
            el.querySelector(".contents"),
            1,
            {
              y: 300
            },
            {
              y: 0,
              ease: Power0.easeInOut
            }
          );
          const sc = this.$scrollmagic
            .scene({
              offset: 0,
              triggerElement: el,
              triggerHook: 1,
              duration: 1000
            })
            .setTween(tw);
          this.$scrollmagic.addScene(sc);
        });
      },
      async fetchData(scrollTop = false) {
        try {
          const {
            data: {data: response}
          } = await apiWorksDetail(this.$route.params.id);
          this.detailData = response;
          console.log("similarProjectList", response.similarProjectList);
          this.$nextTick(() => {
            if (scrollTop) {
              bus.$emit("winScrollTo", 0, 0, 0);
            }
            this.init();
          });
        } catch (error) {
          console.error(error);
        }
      }
    },
    created() {
      this.fetchData();
    },
    deactivated() {
      this.scene?.destroy(true);
    }
  };
</script>
<style lang="scss" scoped>
  .interview {
    min-width: $globalWidth;
    /*margin-top: 50px;*/
    background-color: #f9f9f9;
    .inner {
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      @include globalWidth();
      /*min-height: 733px;*/
      .info {
        width: 50%;
        padding-bottom: 124px;
        p {
          margin-top: 100px;
          font-size: 18px;
          line-height: 30px;
          strong {
            font-weight: bold;
          }
        }
        ul {
          margin-top: 55px;
          font-size: 14px;
          line-height: 24px;
          color: #6e6e6e;

          li {
            display: flex;
            padding: 4px 0;
            strong {
              flex: 0 0 305px;
            }
            span {
              word-break: keep-all;
            }
          }
        }
      }
      .pm-img {
        padding-top: 100px;
        width: 50%;
        text-align: center;
        img {
          vertical-align: top;
        }
      }
    }
  }
  .section-title {
    margin-top: 110px;
    font-size: 26px;
    line-height: 40px;
    font-weight: bold;
    @include montserrat();
    text-transform: uppercase;
  }
  .key-visual {
    position: relative;
    min-height: 1500px;
    height: 150vh;
    overflow: hidden;
    min-width: $globalWidth;
    .contents {
      z-index: 2;
      display: flex;
      flex-direction: column;
      padding-top: 120px;
      box-sizing: border-box;
      justify-content: center;
      align-items: flex-start;
      height: 100vh;
      min-height: 800px;
      position: relative;
      .txt {
        @include montserrat();
        font-weight: bold;
        font-size: 100px;
        color: #fff;
        line-height: 140px;
        word-break: keep-all;
        // span {
        // }
      }
      .info {
        display: flex;
        margin-top: 100px;
        color: #fff;
        font-size: 20px;
        .name {
          font-family: "Noto Sans KR", Montserrat, sans-serif;
        }
        .date {
          @include montserrat();

          margin-left: 60px;
        }
        .desc {
          @include montserrat();
          margin-left: 120px;
        }
      }
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      min-width: $globalWidth;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
    }
  }
  .project-desc {
    display: flex;
    align-items: center;
    min-width: $globalWidth;
    max-width: 1760px;
    box-sizing: border-box;
    margin: 0 auto;
    height: 600px;
    line-height: 70px;
    font-size: 44px;
    font-weight: 700;
    background-position: 50% 50%;
    .inner {
      margin: 0 auto;
      @include globalWidth();
    }
  }
  .project-goal {
    min-width: $globalWidth;
    max-width: 1760px;
    min-height: 880px;
    margin: 0 auto;
    &:before {
      content: "";
      height: 1px;
      display: block;
    }
    .inner {
      position: relative;
      margin: 0 auto;
      @include globalWidth();
      .tit {
        margin-top: 114px;
        @include montserrat();
        display: block;
        font-size: 26px;
        font-weight: bold;
        line-height: 30px;
        text-transform: uppercase;
        color: #fff;
      }
      .logo {
        margin-top: 93px;
      }
      .desc {
        display: block;
        margin-top: 90px;
        font-size: 18px;
        line-height: 30px;
        color: #fff;
      }
    }
  }
  .project-info {
    min-width: $globalWidth;
    padding: 120px 0;
    .contents {
      color: #000;
      .title-box {
        display: flex;
        align-items: flex-start;
        .tit {
          flex: 0 0 auto;
          min-width: 300px;
          text-transform: uppercase;
          @include montserrat();
          display: block;
          position: relative;
          box-sizing: border-box;
          font-size: 14px;
          line-height: 40px;
          padding: 0 10px 0 27px;
          &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            height: 12px;
            width: 12px;
            margin-top: -6px;
            border-radius: 50%;
            background: $red;
          }
        }
        .desc {
          flex: 1 1 auto;
          display: block;
          font-size: 24px;
          line-height: 40px;
          font-weight: bold;
          letter-spacing: -0.05em;
          word-break: keep-all;
        }
      }
      img {
        margin-top: 120px;
      }
    }
    &.design-concept {
      margin-top: -70px;

      /*   padding: 50px 0;*/
    }
  }
  .similar-projects {
    min-width: $globalWidth;
    padding: 36px 0 100px;
    overflow: hidden;
    .similar-inner {
      @include globalWidth();
      margin: 0 auto;
    }
    .similar-title {
      font-size: 32px;
      font-weight: bold;
      line-height: 1.4;
      letter-spacing: -0.03em;
      em {
        color: $red;
        font-style: normal;
      }
    }
    .similar-swiper {
      margin-top: 50px;
      padding-left: max(calc((100vw - #{$globalWidth}) / 2 + 20px), 20px);
      padding-right: 20px;
      overflow: visible;
    }
    .similar-slide {
      width: 552px;
      a,
      .similar-link {
        display: block;
        &:hover .thumb {
          transform: scale3d(0.97, 0.97, 1);
          img {
            transform: scale3d(1.05, 1.05, 1);
          }
        }
      }
      .thumb {
        border-radius: 20px;
        overflow: hidden;
        transition: transform 0.4s ease;
        img {
          width: 100%;
          vertical-align: top;
          object-fit: cover;
          aspect-ratio: 552 / 380;
          transition: transform 0.4s ease;
        }
      }
      .info {
        .circle {
          display: block;
          width: 12px;
          height: 12px;
          margin-top: 24px;
          border-radius: 50%;
          background: $red;
        }
        .title {
          margin-top: 24px;
          font-size: 24px;
          font-weight: bold;
          line-height: 24px;
          letter-spacing: -1.2px;
          color: #000;
        }
        .desc {
          margin-top: 20px;
          font-size: 14px;
          color: #a0a0a0;
          line-height: 14px;
        }
        .more {
          display: inline-block;
          margin-top: 40px;
          font-size: 14px;
          color: #EE2C3C;
          border-bottom: 1px solid #EE2C3C;
          @include montserrat();
        }
      }
    }
    .back-btn-wrap {
      margin-top: 100px;
      display: flex;
      justify-content: center;
    }
    .back-btn {
      display: flex;
      align-items: center;
      gap: 20px;
      padding: 10px 18px 10px 10px;
      border-radius: 100px;
      background: rgba(238, 238, 238, 0.8);
      box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      .ico-project {
        width: 56px;
        height: 56px;
        flex-shrink: 0;
      }
      .txt {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.2;
        color: #000;
        @include montserrat();
      }
      .ico-arrow {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
      }
    }
  }
</style>
